import { createSelector } from 'reselect';
import { PushSubscriptionState } from './types';
import { reduxKey, DEFAULT_PUSH_SUBSCRIPTIONS } from './constants';
function getSlice(state) {
    return state[reduxKey] || {
        pushSubscriptionState: PushSubscriptionState.LOADING,
        send: DEFAULT_PUSH_SUBSCRIPTIONS
    };
}
export const getPushSubscriptionState = createSelector(getSlice, (slice)=>slice.pushSubscriptionState);
export const getPushSubscriptions = createSelector(getSlice, (slice)=>slice.send);

//# sourceMappingURL=selectors.js.map